export default defineNuxtRouteMiddleware((to, from) => {
  const organizationStore = useOrganizationStore();
  const userStore = useUserStore();

  if (
    userStore.isLoggedIn &&
    !userStore.isProfileCompleted &&
    to.path != "/" &&
    to.path != `/${organizationStore.organizationUrl}`
  ) {
    return `/${organizationStore.organizationUrl}`;
  }
});
